<template>
	<div>

	</div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";

// doRendering is a store property that controls wether the scene gets rendered
// We can add features to stop rendering here e.g. if the user doesnt move 
export default {
    computed: {
        ...mapGetters(['isDialogueOpen','loadingscreenVisible']),
    },
    methods: {
        ...mapMutations(["setDoRendering"]),
    },
    watch: {
        // isDialogueOpen is a store property that is true if a dialogue is open (e.g. MapDialogue, LoginDialogue, ShareDialogie)
        // if a dialogue is open we dont want the scene to get rendered
        isDialogueOpen(){
            this.setDoRendering(!this.isDialogueOpen);
        },

        // loadingscreenVisible is a store property that is true if the loadingscreen is visible
        // if the loadingscreen is visible we dont want the scene to get rendered
        loadingscreenVisible(){
            this.setDoRendering(!this.loadingscreenVisible);
        }
    }
}
</script>